import "core-js/modules/es.array.find";
import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import viewArticles from "./components/viewArticles.vue";
import { loadMoreList, commonData } from "@/mixins/index";
import api from '@/api';
export default {
  name: "gatewayUser",
  mixins: [loadMoreList, commonData],
  components: {
    viewArticles: viewArticles
  },
  data: function data() {
    return {
      datePicker: [],
      pagingReqFn: "gateUserList",
      userStatus: [{
        label: "正常",
        value: 1
      }, {
        label: "封禁",
        value: 2
      }],
      //订单状态
      paramsData: {
        isMustAppid: 1
      },
      loginTypeList: [{
        label: "账号登录",
        value: 1,
        url: 'accountLogin'
      }, {
        label: "邮箱登录",
        value: 2,
        url: 'emailLogin'
      }, {
        label: "手机号登陆",
        value: 3,
        url: 'phoneLogin'
      }, {
        label: "第三方登录",
        value: 4,
        url: 'oauthList'
      }, {
        label: "游客登录",
        value: 5,
        url: 'touristLogin'
      }],
      expData: []
    };
  },
  activated: function activated() {
    this.getcommonData(['appListAllData']);
  },
  methods: {
    userskip: function userskip(row, item) {
      var data = {};

      if (row.detail.length == 1) {
        data = this.loginTypeList.find(function (i) {
          return i.value == row.detail[0].login_type;
        });
      } else {
        data = this.loginTypeList.find(function (i) {
          return i.value == item.login_type;
        });
      }

      this.routerLink(data, row);
    },
    routerLink: function routerLink(data, row) {
      this.$router.push({
        name: data.url,
        params: {
          user_id: row.login_user_id,
          appid: this.paramsData.appid
        }
      });
    },
    userStatusChange: function userStatusChange(e, row, index, value) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$confirm('请确认当前操作?', '确认', {
                  confirmButtonText: '确认',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(function () {
                  _this.$api.gateUserBan({
                    appid: row.appid,
                    id: row.id,
                    status: value,
                    isMustAppid: 1
                  }).then(function (res) {
                    if (res.status == 200) {
                      var _index = _this.tableData.findIndex(function (i) {
                        return i.id == row.id;
                      });

                      _this.tableData[_index].status = value;

                      _this.$message.success('修改成功');
                    }
                  });
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleSortChange: function handleSortChange(_ref) {
      var prop = _ref.prop,
          order = _ref.order;

      if (order) {
        this.paramsData.orderBy = order == 'ascending' ? 'asc' : 'desc';
      } else {
        this.paramsData.orderBy = '';
      }

      this.getList(1);
    },
    exportDataFn: function exportDataFn() {
      var _this2 = this;

      api[this.pagingReqFn](_objectSpread(_objectSpread({}, this.paramsData), {}, {
        page: 1,
        page_size: this.total + 10
      })).then(function (res) {
        if (res.status == 200) {
          var columns = [{
            label: '应用名称',
            prop: 'appName'
          }, {
            label: '网关用户ID',
            prop: 'gate_user_id'
          }, {
            label: '用户ID',
            prop: 'login_user_id'
          }, {
            label: '登录方式',
            prop: 'detail'
          }, {
            label: '用户状态',
            prop: 'status'
          }];
          _this2.expData = res.data.data;

          _this2.expData.forEach(function (item) {
            if (item.detail.length) {
              item.detail = item.detail.map(function (i) {
                return i.type_name;
              }).toString();
            }

            item.status = item.status == 1 ? "正常" : "封禁";
          });

          _this2.$export.excel({
            columns: columns,
            data: _this2.expData,
            title: _this2.$route.meta.title
          });
        }
      });
    }
  }
};